import * as R from "ramda";
import React, { useContext, useMemo } from "react";
import { useSelector } from "react-redux";
import * as UserRedux from "../../redux/user";

// pathname is a required property that we instantiate immediately,
// the other properties of the location (ex: href, origin, etc.) are optional
// and will be populated later in the loading process
export const LocationContext = React.createContext<Partial<Location> & { pathname: string }>({
  pathname: "",
});

const useLocation = (): { location: Partial<Location> & { pathname: string }; company: string } => {
  const location = useContext(LocationContext);

  const companies = useSelector(UserRedux.companiesSelector) as { company: string }[];

  const company = useMemo(() => {
    if (!(location && companies)) {
      return "";
    }
    const { pathname } = location;
    let companyMatch = pathname.match(/\/([^/]*)/) || [];
    if (R.length(companyMatch) >= 2) {
      let foundCompany = R.find(elem => elem.company === companyMatch[1], companies) || {
        company: "",
      };
      return foundCompany.company;
    }

    return "";
  }, [location, companies]);

  return { location, company };
};

export default useLocation;
